export default __webpack_public_path__ + "assets/images/play-icon-a7b4477c.svg";